import { render, staticRenderFns } from "./_couponsTable.vue?vue&type=template&id=623c35a7"
import script from "./_couponsTable.vue?vue&type=script&lang=js"
export * from "./_couponsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports